import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const CrossIcon = ({ stroke, ...props }: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.9399 6.06055L6.06055 17.9399M6.06055 6.06055L17.9399 17.9399"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </svg>
  );
};
